import { setup } from 'xstate'

type CardFormMachineEvents = { type: 'NEXT' } | { type: 'THROW' }

export type CardFormMachineStates = {
    value: 'FILLING_FORM' | 'PROCESSING' | 'SUCCESS' | 'ERROR'
}

export const cardFormMachine = setup({
    types: {
        events: {} as CardFormMachineEvents,
    },
}).createMachine({
    id: 'cardForm',
    initial: 'FILLING_FORM',
    states: {
        FILLING_FORM: {
            on: {
                NEXT: 'PROCESSING',
            },
        },
        PROCESSING: {
            on: {
                NEXT: 'SUCCESS',
                THROW: 'ERROR',
            },
        },
        SUCCESS: {
            type: 'final',
        },
        ERROR: {
            type: 'final',
        },
    },
})
